import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutesName } from '../../const/AppRoutesName';

export const routes: Routes = [
  {
    path: AppRoutesName.FR.FORGOT_PASSWORD,
    loadComponent: () =>
      import('./forgot-password-2.component').then(
        (m) => m.ForgotPassword2Component,
      ),
  },
  {
    path: AppRoutesName.EN.FORGOT_PASSWORD,
    loadComponent: () =>
      import('./forgot-password-2.component').then(
        (m) => m.ForgotPassword2Component,
      ),
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ForgotPassword2Module {}
